import { Model } from "survey-core";

import { DateTime } from "@bps/date-time";

import { DocumentDownloadData } from "../api/form";

export enum FormStatusEnum {
  Loading = "Loading",
  Available = "Available",
  Preview = "Preview",
  Initialising = "Initialising",
  NotFound = "Not Found",
  DecodeError = "Decode Error",
  AlreadyCompleted = "Already Completed",
  Expired = "Expired",
  Cancelled = "Cancelled",
  Completed = "Completed",
  QrCode = "QrCode",
  PinRequired = "PinRequired",
  TooManyAttempts = "TooManyAttempts",
  IsReadOnly = "IsReadOnly"
}

export interface FormStatus {
  status: FormStatusEnum;
  description?: string;
  form?: Model;
  expiry?: DateTime;
  helpText?: string;
  testform?: boolean;
  titleFields?: Record<string, string>;
  formDisplaySettings?: FormDisplaySettings;
  isReadOnly?: boolean;
  documentDownloadCallBackUrl?: string;
  variables?: any;
}

export interface FormDisplaySettings {
  headerImageUrl?: string;
  footerImageUrl?: string;
  headerText?: string;
  footerText?: string;
}

export interface FormApiOutput extends FormStatus {
  loading: boolean;
  setDeveloperPreviewForm: (form: string) => void;
  submitPin: (pin: string) => Promise<void>;
  formId: string;
  getDocumentDownloadData: () => Promise<DocumentDownloadData>;
}
